import * as R from 'ramda';
import parseFollower from './parseFollower';

export default function parseFollowers(items) {
  return R.map(parseFollower, items);
}
